import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>1e declinatie</th>
          <th>2e declinatie</th>
          <th>3e declinatie</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            femin–
            <span style={{ fontWeight: "bold" }}>a</span>
          </td>
          <td>
            serv–
            <span style={{ fontWeight: "bold" }}>us</span>
          </td>
          <td>rex</td>
        </tr>
        <tr>
          <th className="col bor-bot">acc. ev.</th>
          <td className="bor-bot">
            femin–
            <span style={{ fontWeight: "bold" }}>am</span>
          </td>
          <td className="bor-bot">
            serv–
            <span style={{ fontWeight: "bold" }}>um</span>
          </td>
          <td className="bor-bot">
            reg–
            <span style={{ fontWeight: "bold" }}>em</span>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            femin–
            <span style={{ fontWeight: "bold" }}>ae</span>
          </td>
          <td>
            serv–
            <span style={{ fontWeight: "bold" }}>i</span>
          </td>
          <td>
            reg–
            <span style={{ fontWeight: "bold" }}>es</span>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            femin–
            <span style={{ fontWeight: "bold" }}>as</span>
          </td>
          <td>
            serv–
            <span style={{ fontWeight: "bold" }}>os</span>
          </td>
          <td>
            reg–
            <span style={{ fontWeight: "bold" }}>es</span>
          </td>
        </tr>
      </table>
    </div>
    <p>
      <Letop>
        De nominativus enkelvoud in <strong>rex</strong> heeft geen uitgang. Dat
        komt omdat deze vorm onregelmatig is. Om de stam te bepalen moet je de
        meervoudsvorm leren (of opzoeken).
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/znw-1.js